module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-bottom-backplates.eccfd8e4.png";